import type { PaginationRequest } from '@kimuno/api-sdk';

import { loadOnRefreshLimit, searchSettings } from '../constants';
import type { Pagination } from '../types/AppContent';
import type { Pagination as SearchPagination } from '../types/search';

export function createPaginationRequest(pagination: Pagination): PaginationRequest {
	const { limit, offset, sortOrder } = pagination;

	return {
		limit,
		offset,
		sortOrder,
		version: 2,
	};
}

export function createNextPaginationRequest(pagination: Pagination): PaginationRequest {
	return createPaginationRequest({
		...pagination,
		offset: pagination.offset + pagination.limit,
	});
}

export function hasNext(pagination: Pagination | SearchPagination) {
	return (
		pagination.offset <= searchSettings.maxOffset &&
		((pagination.total === -1 && pagination.offset === 0) || pagination.total > pagination.offset)
	);
}

// The one request that rebuilds a results list after a full page load: every result the
// user had loaded, capped at the search API's per-request maximum. A count that fits in the
// first page needs no rebuild — the regular first request covers it.
export function getRestorePagination(numberOfItems: number): SearchPagination | undefined {
	if (numberOfItems <= searchSettings.itemsPerPage) {
		return undefined;
	}
	return { offset: 0, limit: Math.min(numberOfItems, loadOnRefreshLimit), total: -1 };
}
